// Grammar stays out of the way (Requirement 56): a sense reads as its word
// and meaning, "imite — imitates", not "imite (3rd person singular, present
// tense of imiter) — imitates". Yasna's sense_label (its grammatical
// description) is shown only where it is needed to tell two senses apart:
// when another sense in the same list has the same word and meaning.

export const describeSense = (sense) => {
  if (!sense) return '';
  if (sense.short_gloss) return `${sense.word} — ${sense.short_gloss}`;
  return sense.sense_label ? `${sense.word} (${sense.sense_label})` : sense.word;
};

/** The sense_label to show for `sense` in `list`, or null. */
export function distinguishingLabel(sense, list = []) {
  if (!sense || !sense.sense_label) return null;
  const same = (a, b) => (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();
  const twin = list.some((o) => o !== sense && o.word_sense_id !== sense.word_sense_id
    && same(o.word, sense.word) && same(o.short_gloss, sense.short_gloss));
  return twin || !sense.short_gloss ? sense.sense_label : null;
}
